import Mac88 from '../../assets/images/provider_img/mac88.webp';
import Mac88Virtual from '../../assets/images/provider_img/mac88-virtual.webp';
import FunGames from '../../assets/images/provider_img/fun-games.webp';
import Evolution from '../../assets/images/provider_img/evolution-gaming.webp';
import Spribe from '../../assets/images/provider_img/spribe.webp';
import Turbo from '../../assets/images/provider_img/turbo-games.webp';
import Smartsoft from '../../assets/images/provider_img/smartsoft.webp';
import Ezugi from '../../assets/images/provider_img/ezugi.webp';
import Jili from '../../assets/images/provider_img/Jili.webp';
import AeSexy from '../../assets/images/provider_img/sexy.webp';
import Playtech from '../../assets/images/provider_img/playtech.webp';
import Betsoft from '../../assets/images/provider_img/betsoft.webp';
import Gamzix from '../../assets/images/provider_img/gamzix.webp';
import BetGames from '../../assets/images/provider_img/betgamestv.webp';
import MacExcite from '../../assets/images/provider_img/mac_excite.webp';
import Live88 from '../../assets/images/provider_img/live88.webp';
import King from '../../assets/images/provider_img/kingmaker.webp';
import RG from '../../assets/images/provider_img/royal-gaming.webp';

export const HomeProvidersIcons = [
  { icon: Mac88, subProviderName: 'MAC88' },
  { icon: FunGames, subProviderName: 'FUN GAMES' },
  { icon: Mac88Virtual, subProviderName: 'MAC88 VIRTUALS' },
  { icon: Spribe, subProviderName: 'SPRIBE' },
  { icon: Evolution, subProviderName: 'EVOLUTION' },
  { icon: Turbo, subProviderName: 'TURBO' },
  { icon: Smartsoft, subProviderName: 'SMARTSOFT' },
  { icon: Ezugi, subProviderName: 'EZUGI' },
  { icon: Jili, subProviderName: 'JILI' },
  { icon: AeSexy, subProviderName: 'AE SEXY' },
  // { icon: Playtech, subProviderName: 'PLAYTECH' },
  { icon: Betsoft, subProviderName: 'BETSOFT' },
  { icon: Gamzix, subProviderName: 'GAMZIX' },
  { icon: BetGames, subProviderName: 'BetGames_TV' },
  { icon: MacExcite, subProviderName: 'MAC EXCITE' },
  { icon: Live88, subProviderName: 'Bombay Live' },
  { icon: King, subProviderName: 'KINGMAKER' },
  // { icon: RG, subProviderName: 'ROYAL GAMING' },
];

export const HomeMobProvidersIcons = [
  { icon: Mac88, subProviderName: 'MAC88' },
  { icon: Evolution, subProviderName: 'EVOLUTION' },
  { icon: Turbo, subProviderName: 'TURBO' },
  { icon: Smartsoft, subProviderName: 'SMARTSOFT' },
  // { icon: Playtech, subProviderName: 'PLAYTECH' },
  { icon: Jili, subProviderName: 'JILI' },
  { icon: FunGames, subProviderName: 'FUN GAMES' },
  { icon: Spribe, subProviderName: 'SPRIBE' },
  { icon: AeSexy, subProviderName: 'AE SEXY' },
  { icon: MacExcite, subProviderName: 'MAC EXCITE' },
  { icon: Gamzix, subProviderName: 'GAMZIX' },
  { icon: BetGames, subProviderName: 'BetGames_TV' },
  { icon: Mac88Virtual, subProviderName: 'MAC88 VIRTUALS' },
  { icon: Ezugi, subProviderName: 'EZUGI' },
  { icon: Betsoft, subProviderName: 'BETSOFT' },
  { icon: Live88, subProviderName: 'Bombay Live' },
  // { icon: King, subProviderName: 'KINGMAKER' },
  // { icon: RG, subProviderName: 'ROYAL GAMING' },
];

// Sport icons mapping
export const sportIconsMap = {
  '4': require('../../assets/images/home_page/sport_icons/cricket.webp'),
  '1': require('../../assets/images/home_page/sport_icons/football.webp'),
  '2': require('../../assets/images/home_page/sport_icons/tennis.webp'),
  '99994': require('../../assets/images/home_page/sport_icons/kabaddi.webp'),
  '7522': require('../../assets/images/home_page/sport_icons/basketball.webp'),
  '7511': require('../../assets/images/home_page/sport_icons/baseball.webp'),
  '4339': require('../../assets/images/home_page/sport_icons/greyhound.webp'),
  '7': require('../../assets/images/home_page/sport_icons/horserace.webp'),
  'sr:sport:23': require('../../assets/images/home_page/sport_icons/volleyball.webp'),
  'sr:sport:22': require('../../assets/images/home_page/sport_icons/darts.webp'),
  'sr:sport:29': require('../../assets/images/home_page/sport_icons/futsal.webp'),
  'sr:sport:20': require('../../assets/images/home_page/sport_icons/table-tennis.webp'),
  '99990': require('../../assets/images/home_page/sport_icons/binary.webp'),
  '2378961': require('../../assets/images/home_page/sport_icons/politics.webp'),
  'sr:sport:4': require('../../assets/images/home_page/sport_icons/ice-hockey.webp'),
  'sr:sport:117': require('../../assets/images/home_page/sport_icons/mma.webp'),
  'sr:sport:12': require('../../assets/images/home_page/sport_icons/rugby.webp'),
};

export const sportNamesMap = {
  '4': 'Cricket',
  '1': 'Football',
  '2': 'Tennis',
  '99994': 'Kabaddi',
  '7522': 'Basketball',
  '7511': 'Baseball',
  '4339': 'Greyhound',
  '7': 'Horse Race',
  'sr:sport:23': 'Volleyball',
  'sr:sport:22': 'Darts',
  'sr:sport:29': 'Futsal',
  'sr:sport:20': 'Table Tennis',
  '99990': 'Binary',
  '2378961': 'Politics',
  'sr:sport:4': 'Ice Hockey',
  'sr:sport:117': 'MMA',
  'sr:sport:12': 'Rugby',
};
